document.addEventListener("DOMContentLoaded", function() {
  showHeader();
  toggleMenu();
  closeMenu();
  handleHeaderOnScroll();
  accordionMenu();
})

function showHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  header.classList.add('is-show');

  header.addEventListener('animationend', () => {
    showPageTitle();
    sectionFadeIn();
  })
}

function throttle(fn, wait) {
  let lastTime = 0;
  let timeout;
  return function(...args) {
    const now = Date.now();
    if (now - lastTime >= wait) {
      lastTime = now;
      fn.apply(this, args);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        lastTime = Date.now();
        fn.apply(this, args);
      }, wait - (now - lastTime));
    }
  };
}

function toggleMenu() {
  const menuButton = document.getElementById('header-menu-button');
  
  if (!menuButton) return;

  menuButton.addEventListener('click', () => {
    document.body.classList.toggle('is-open-menu');
  })
}

function closeMenu() {
  const menuBackground = document.getElementById('menu-background');

  if (!menuBackground) return;

  menuBackground.addEventListener('click', () => {
    document.body.classList.remove('is-open-menu');
  })
}

function handleHeaderOnScroll() {
  const header = document.querySelector('.header');
  const layoutMain = document.querySelector('.layout-main');
  const footer = document.querySelector('.footer');
  if (!header) return;

  const isSP = window.matchMedia('(max-width: 960px)').matches;

  const onScroll = throttle(() => {
    if (isSP && layoutMain && footer) {
      // SP時: .layout-mainの位置に来たらis-scrolled付与
      const mainTop = layoutMain.getBoundingClientRect().top + window.scrollY - 60; // 60pxはヘッダーの高さを考慮
      const footerTop = footer.getBoundingClientRect().top + window.scrollY - 60;

      if (window.scrollY >= mainTop && window.scrollY <= footerTop) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
      }
    } else {
      if (window.scrollY > 0) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
      }
    }
  }, 100);

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll); // 画面幅変更時も再判定
  onScroll(); // 初回実行
}

function showPageTitle() {
  const pageTitle = document.getElementById('page-title');

  if (!pageTitle) return;

  const titleLength = pageTitle ? pageTitle.querySelectorAll('span').length : 0;
  pageTitle.querySelectorAll('span').forEach(span => {
    span.classList.add('is-show');

    if (span.dataset.order == titleLength) {
      span.addEventListener('animationend', () => {
        const pageSubTitle = document.getElementById('page-subtitle');

        if (!pageSubTitle) return;

        pageSubTitle.classList.add('is-show');
      });
    }
  })
}

function sectionFadeIn() {
  const mediaSections = document.getElementById('media');
  const storeSections = document.getElementById('store');
  const seminarSections = document.getElementById('seminar');

  if (!mediaSections || !storeSections || !seminarSections) return;

  mediaSections.classList.add('is-show');
  storeSections.classList.add('is-show');
  seminarSections.classList.add('is-show');

  seminarSections.addEventListener('animationend', () => {
    showBorder();
  })
}

function showBorder() {
  const linksElements = document.querySelectorAll('.media');
  if (!linksElements) return;
  linksElements.forEach(link => {
    link.classList.add('is-active');
  });
}

function accordionMenu(){
  let menuItems = document.querySelectorAll('ul.accordion__list--title li');
  let self =this;
  for (let item of menuItems) {
    item.addEventListener("click",function(e){
      e.stopPropagation();
      let id= this.querySelector(".menu-title").getAttribute("menu-id");
      let elem = document.getElementById('footer-menu-'+id);
      let menu = document.querySelector(".media-menu");
      if(!this.classList.contains("is-active")){
        self.closeAccordionMenu();
        this.classList.add("is-active");
        elem?.classList.add("is-show");
        menu?.classList.add("is-show");
      }else{
        this.classList.remove("is-active");
        elem?.classList.remove("is-show");
        menu?.classList.remove("is-show");
      }
    })
  }
  let level2Items = document.querySelectorAll('.--level-2 li div.head');
  for (let level2 of level2Items) {
    level2.addEventListener("click",function(e){
        e.stopPropagation();
        let list = e.target.nextElementSibling;
        if(e.target.classList.contains("is-current")){
          e.target.classList.remove("is-current");
        }else{
          e.target.classList.add("is-current");
        }
        if(list.style?.display=="flex"){
          list.style.display=null;
        }else{
          list.style.display="flex";
        }

    });
  }
}
function closeAccordionMenu(){
  // let menuItems = document.querySelectorAll('.is-show');
  let menuItems = document.querySelectorAll('ul.accordion__list.--level-1');
  for (let item of menuItems){
    item.classList.remove("is-show");
  }
  let tabs = document.querySelectorAll('ul.accordion__list--title li');
  for (let tab of tabs) {
    tab.classList.remove("is-active")
  }
}

